import { render } from "./address.vue?vue&type=template&id=ad534aae&scoped=true&ts=true"
import script from "./address.vue?vue&type=script&lang=ts"
export * from "./address.vue?vue&type=script&lang=ts"

import "./address.vue?vue&type=style&index=0&id=ad534aae&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad534aae"]])

export default __exports__